var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar"},[_c('van-tabbar',{model:{value:(_vm.ac),callback:function ($$v) {_vm.ac=$$v},expression:"ac"}},[_c('van-tabbar-item',{attrs:{"icon":"home-o","to":"/home"}},[_vm._v("首页")]),_c('van-tabbar-item',{attrs:{"icon":"contact","to":"/user"}},[_vm._v("我的")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }